import { Project } from '../types';

export const projects: Project[] = [
    {
        title: "MoralityCode AI",
        category: "Mobile",
        status: "Live",
        featured: true,
        description: "Cross-platform AI ethics training app built with Flutter, published on both Google Play Store and App Store. Developed as a UN volunteer with Action Lab for Development, supporting UN SDG Goal 9.",
        highlights: [
            "Published on Google Play & App Store — available worldwide",
            "Built from scratch with Flutter + Clean Architecture + BLoC",
            "Automated iOS deployment via CodeMagic CI/CD pipeline",
            "120+ hours contributed as UNV-certified Online Volunteer"
        ],
        githubLink: "",
        liveLink: "https://apps.apple.com/us/app/moralitycode/id6756179566",
        liveLink2: "https://play.google.com/store/apps/details?id=com.action_lab.morality_code",
        liveLabel: "App Store",
        liveLabel2: "Google Play",
        technologies: ["Flutter", "Dart", "BLoC", "Clean Architecture", "CodeMagic", "iOS", "Android"]
    },
    {
        title: "GBCMobile — DeFi dApp",
        category: "Web3",
        status: "Live",
        featured: true,
        description: "Real-time DeFi dashboard on the SUI Network supporting token swaps, Move-based reward distribution, and multi-wallet integration, serving 2,000+ holders with 95% uptime.",
        highlights: [
            "1,000+ tokens & 50+ NFTs distributed via gas-optimized Move contracts",
            "70% increase in 45-day user retention after deployment",
            "5+ SUI wallets integrated with 90% successful connection rate"
        ],
        githubLink: "",
        liveLink: "https://gbckw.com/",
        liveLabel: "Visit Site",
        technologies: ["SUI Network", "Move", "DeFi", "Smart Contracts", "NFT", "Next.js"]
    },
    {
        title: "TALBK — Delivery System",
        category: "Mobile",
        status: "Live",
        featured: true,
        description: "Multi-role delivery platform serving merchants, clients, and delivery personnel. Led a team of 9 engineers to build and ship a full Flutter + Laravel system with real-time GPS tracking.",
        highlights: [
            "75% productivity boost through Agile team leadership",
            "80% reduction in server load after refactoring 10+ APIs",
            "90% drop in customer support escalations"
        ],
        githubLink: "",
        liveLink: "https://linktr.ee/TALBK",
        liveLabel: "Download App",
        technologies: ["Flutter", "Laravel", "GetX", "Firebase", "Google Maps", "MySQL"]
    },
    {
        title: "Frreen — Flight Booking App",
        category: "Mobile",
        status: "Live",
        featured: true,
        description: "Cross-platform Flutter flight ticket reservation app with 30+ screens, social sign-in, and AWS-backed real-time data. Processed 10,000+ rows of airline data with 90% improved response times.",
        highlights: [
            "30+ screens with complex navigation and responsive UI/UX",
            "35% user growth via Google, Apple & Facebook sign-in",
            "50% server latency reduction through AWS backend optimizations"
        ],
        githubLink: "",
        liveLink: "https://linktr.ee/frreen",
        liveLabel: "Download App",
        technologies: ["Flutter", "Dart", "BLoC", "Clean Architecture", "AWS", "HIVE"]
    },
    {
        title: "AlSardari Law Firm",
        category: "Web",
        status: "Live",
        featured: false,
        description: "Professional website for a law firm with responsive design, multilingual support, and a clean modern aesthetic.",
        highlights: [
            "Fully responsive across all devices",
            "SEO-optimized and fast-loading",
            "Modern UI with Next.js and Tailwind CSS"
        ],
        githubLink: "",
        liveLink: "https://alsardarilaw.com/",
        liveLabel: "Visit Site",
        technologies: ["Next.js", "TypeScript", "Tailwind CSS", "Laravel"]
    },
    {
        title: "Olavia Partners",
        category: "Web",
        status: "Live",
        featured: false,
        description: "Corporate website for a professional services firm, built with clean architecture, smooth animations, and professional presentation.",
        highlights: [
            "Responsive layout with smooth animations",
            "Optimized for performance and SEO",
            "Delivered within a 3-week deadline"
        ],
        githubLink: "",
        liveLink: "https://olavirapartners.com/",
        liveLabel: "Visit Site",
        technologies: ["Next.js", "TypeScript", "Tailwind CSS"]
    },
    {
        title: "Expert ELS",
        category: "Web",
        status: "Live",
        featured: false,
        description: "Educational language services website with course listings, student inquiry flow, and a CMS for administrators.",
        highlights: [
            "CMS for easy content updates by non-technical admins",
            "Student enrollment and inquiry flow",
            "Mobile-first responsive design"
        ],
        githubLink: "",
        liveLink: "https://expert-els.com/",
        liveLabel: "Visit Site",
        technologies: ["Next.js", "Laravel", "MySQL", "Tailwind CSS"]
    },
    {
        title: "Knowledge4All — UNDP Portal",
        category: "Web",
        status: "Live",
        featured: false,
        description: "Contributed as Quality Assurance Engineer to the UN's flagship global knowledge-sharing platform under UNDP.",
        highlights: [
            "End-to-end QA covering functionality, security, and UX",
            "Enhancement proposals adopted by UNDP development team",
            "Collaborated directly with UNDP's digital development team"
        ],
        githubLink: "",
        liveLink: "https://www.knowledge4all.com/",
        liveLabel: "Visit Platform",
        technologies: ["QA Engineering", "UX Testing", "Security Audit", "UNDP"]
    },
    {
        title: "Your Store — Ecommerce App",
        category: "Mobile",
        status: "Completed",
        featured: false,
        description: "Feature-rich cross-platform ecommerce app with product search, favorites, cart management, and order processing.",
        highlights: [
            "BLoC state management for scalable business logic",
            "Offline-first with SQLite local caching",
            "Smooth UI built with Figma-designed screens"
        ],
        githubLink: "https://github.com/AliRajab12/flutter_ecommerce_app",
        liveLink: "https://www.youtube.com/watch?v=rD8zsHczDuM&list=PLVHI1VUbMtuItLu2XErbvLjB3-k8h78ny&index=2",
        liveLabel: "Watch Demo",
        technologies: ["Flutter", "Dart", "BLoC", "SQLite", "Figma"]
    }
];
